export const brickstreamDataUploadCorrectValues = {
    dataUploadInterval: '15',
    dataUploadGranularity: '1',
};
